"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGolfDayDistribution = void 0;
const getGolfDayDistribution = (number_of_rounds, number_of_nights) => {
    // Create an array initialized with 'false', representing days without golf.
    const result = new Array(number_of_nights + 1).fill(false);
    if (number_of_rounds === 0) {
        return result; // No golf rounds to schedule.
    }
    // Adjust the range to avoid the first and last day unless necessary.
    let start = 1; // Start scheduling from the second day.
    let end = number_of_nights; // End scheduling one day before the last day.
    // Calculate the number of days available excluding the first and last day.
    let availableDays = end - start + 1;
    // If the rounds exceed the days available, include the first and last days.
    if (number_of_rounds > availableDays) {
        if (number_of_rounds === number_of_nights + 1) {
            // If rounds equal the total days, schedule golf every day.
            return result.fill(true);
        }
        // Adjust start and end to include the first and last days.
        start = 0;
        end = number_of_nights;
        availableDays += 2;
    }
    // Calculate the interval for golf days.
    const golfInterval = availableDays / number_of_rounds;
    // Distribute the golf rounds across the available days.
    for (let i = 0; i < number_of_rounds; i++) {
        // Compute the index for a golf day.
        const index = Math.floor(start + i * golfInterval);
        result[index] = true;
    }
    return result;
};
exports.getGolfDayDistribution = getGolfDayDistribution;
